import { useEffect, useState } from 'react';

/** True while the media query matches; false where matchMedia is missing (tests, old browsers). */
export function useMediaQuery(query: string): boolean {
  const get = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(query);
    const on = () => setMatches(mq.matches);
    on();
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, [query]);
  return matches;
}

/** A mouse or trackpad on a screen wide enough for a popover: the site's own pickers (STYLE_GUIDE B-153). */
export const DESKTOP_POINTER = '(pointer: fine) and (min-width: 640px)';
